<template lang="pug">
  .dashboard__table
    .dashboard__table__title
      el-row.grid-content(:gutter="20" style="margin: 0")
        el-col(
          :span="5"
        ) {{ $t('任务') }}
        el-col(
          :span="5"
        ) {{ $t('项目ID') }}
        el-col(
          :span="5"
        ) {{ $t('项目') }}
        el-col(
          v-if="type === 1"
          :span="5"
        ) {{ $t('Sub SOW') }}
        el-col(
          :span="4"
        ) {{ $t('接收时间') }}
        el-col(
          v-if="type === 0"
          :span="4"
        ) {{ $t('截止时间') }}
    .dashboard__table__content
      table-row(
        v-for="item,index in data"
        :data="item"
        :key="index"
        :type="type"
      )

</template>

<script>
import TableRow from './TableRow'

export default {
  components: {
    TableRow
  },
  props: {
    data: {
      type: Array,
      default () {
        return null
      }
    },
    type: {
      type: Number,
      default () {
        return 1
      }
    }
  }
}
</script>

<style lang="stylus">
.dashboard__table__title
  > .el-row
    background linear-gradient(to left, rgb(111, 167, 186), rgb(97, 168, 235) 34%, rgb(51, 112, 210))
    > .el-col
      height 48px
      display flex
      align-items center
      color: #fff
      font-size: 16px
      font-weight: 400

.dashboard__table__content
  height 250px
  overflow auto
</style>
